import { aspectReducer } from './reducer';

export const aspectRootReducer = aspectReducer;

export const aspectRootReducerStateKey = 'aspect';
